export default class AdditionalContactDetails {
  contactGid: string;
  contactXid: string;
  contactName: string;
  jobTitle: string;
  emailAddress: string;
  phone1: string;
  operation: string;
  active: boolean;
  isDelete: boolean;

  constructor(
    contactGid: string,
    contactXid: string,
    contactName: string,
    jobTitle: string,
    emailAddress: string,
    phone1: string,
    operation: string,
    active: boolean,
    isDelete: boolean
  ) {
    this.contactGid = contactGid;
    this.contactXid = contactXid;
    this.contactName = contactName;
    this.jobTitle = jobTitle;
    this.emailAddress = emailAddress;
    this.phone1 = phone1;
    this.operation = operation;
    this.active = active;
    this.isDelete = isDelete;
  }
}
